import {PhoneNumber} from './PhoneNumber';

export type PhoneNumberData = {
  type: string | null;
  phoneNumber: PhoneNumber;
};
